const Text = {
  variants: {
    helper: props => ({
      fontSize: "xs",
      color: props.colorMode === "dark" ? "whiteAlpha.600" : "gray.500"
    })
  }
};

export default Text;